import * as React from "react";
import {UserAchievementInfo} from "../../../generated/protocol";

interface Props {
    info: UserAchievementInfo;
}

export class UserAchievements extends React.Component<Props, {}> {

    getAchievements() {
        return this.props.info.achievements.achievements.map(achievement => {
            return (
                <tr key={achievement.achievementNameId}>
                    <td><img src={achievement.imageUrl} className="" alt="icon" height="32" width="32"/></td>
                    <td>{achievement.name}</td>
                    <td><span className="pie">{achievement.currentCount + '/' + achievement.targetCount}</span></td>
                    <td className="text-navy">
                        {achievement.achieved ? <i className="fa fa-check"></i> : ""}
                    </td>
                </tr>
            )
        });
    }

    render() {
        return (
            <div className="col-sm-12">
                <div className="ibox float-e-margins">
                    <div className="ibox-title">
                        <h2>Achievements</h2>
                    </div>

                    <div className="ibox-content">
                        <table className="table table-hover">
                            <thead>
                            <tr>
                                <th>Icon</th>
                                <th>Name</th>
                                <th>Progression</th>
                                <th>Completed</th>
                            </tr>
                            </thead>
                            <tbody>{this.getAchievements()}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/user/UserAchievements.tsx